import settings from '../../services/settings'

const getCountryFlag = (code) => {
  return `<img class="country-flag" src="${require(`@/assets/img/flags/${code}.svg`)}" alt="${code}" />`
}

const state = {
  messages: [],
  socket: null,
  wsStatus: 'finished',
  wsContinue: false,
  isLimitExceeded: false,
  welcomeMessage: {
    question: '',
    answer: `<span>${settings.translations.welcome} ${getCountryFlag('pl')}<br>${settings.all_translations.en.welcome} ${getCountryFlag('us')}</span>`,
    type: 'welcome'
  }
}
const mutations = {
  updateMessages (state, messages) {
    state.messages = messages
  },
  setMessages (state, messages) {
    state.messages.push(messages)
  },
  resetMessages (state) {
    state.messages = []
  },
  setWsStatus (state, status) {
    state.wsStatus = status
  },
  setWsContinue (state, status) {
    state.wsContinue = status
  }
}
const getters = {
  getMessages (state) {
    return state.messages
  },
  getWsStatus (state, status) {
    return state.wsStatus
  },
  getWsContinue (state) {
    return state.wsContinue
  }
}
const actions = {
  sendMessage ({ commit, state, rootState }, question) {
    return new Promise((resolve, reject) => {
      const uuid = Math.random().toString(16).slice(2)
      const token = localStorage.getItem('accessToken')
      const locationId = localStorage.getItem('locationId')

      commit('setMessages', {
        question,
        answer: '',
        id: uuid
      })

      commit('setWsStatus', 'starting')

      if (this.socket === undefined) {
        this.socket = new WebSocket(state.wsContinue ? `${process.env.VUE_APP_CHAT_WEBSOCKET}/api/v1/qa/ws-chat/continue` : `${process.env.VUE_APP_CHAT_WEBSOCKET}/api/v1/qa/ws-chat/?loc_id=${locationId || 0}`)

        this.socket.onopen = () => {
          this.socket.send(JSON.stringify({ token }))
          if (question === null) {
            return
          }
          this.socket.send(JSON.stringify({ question }))
        }
      } else {
        this.socket.send(JSON.stringify({ question }))
      }

      // this.socket.onclose = function (e) {
      //   console.log('Socket is closed. Reconnect will be attempted in 1 second.', e.reason)
      //   setTimeout(function () {
      //     // connect()
      //     console.log('asd')
      //   }, 1000)
      // }

      this.socket.onmessage = (e) => {
        const response = JSON.parse(e.data)
        const messages = JSON.parse(JSON.stringify(state.messages))
        const findResponse = messages.findIndex(response => response.id === uuid)
        messages[findResponse].answer += response.piece ? response.piece : ''
        messages[findResponse].state = response.state

        if (response.link) {
          messages[findResponse].link = response.link
        }

        commit('setWsStatus', response.state)
        commit('updateMessages', messages)
      }
    })
  },
  welcomeMessage ({ commit, state }) {
    if (state.messages.length) {
      return
    }
    setTimeout(() => {
      commit('updateMessages', state.welcomeMessage)
    }, 600)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
